function applyReviewsIONativeWidgetLayout(widgets = Array.from(document.querySelectorAll('[id^="ReviewsWidget-"], #ReviewsWidget'))) {
  widgets.forEach((widget) => {
    const rightGroup = widget.querySelector('.ElementsWidget__header .header__group--right');
    const section = widget.closest('.shopify-section');

    if (rightGroup) {
      rightGroup.style.setProperty('display', 'none', 'important');
    }

    if (section) {
      section.hidden = isEmptyReviewsWidget(widget);
    }
  });
}

function isEmptyReviewsWidget(widget) {
  const reviewItems = widget.querySelectorAll('.R-ContentList__item');

  if (reviewItems.length > 0) {
    return false;
  }

  const text = widget.textContent?.trim()?.toLowerCase() || '';

  return [
    'no reviews collected',
    'be the first to write a review',
    'keine bewertungen',
    'noch keine bewertungen',
    'sei der erste',
    'sois le premier',
    'soyez le premier',
    'scrivi la prima recensione',
    'sé el primero'
  ].some((emptyStateText) => text.includes(emptyStateText));
}

function observeReviewsIONativeWidgets() {
  let syncTimer = null;

  const queueSync = () => {
    if (syncTimer) {
      return;
    }

    syncTimer = window.setTimeout(() => {
      syncTimer = null;
      applyReviewsIONativeWidgetLayout();
    }, 100);
  };

  queueSync();

  if (!document.body) {
    return;
  }

  const observer = new MutationObserver(queueSync);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observeReviewsIONativeWidgets();
  }, { once: true });
} else {
  observeReviewsIONativeWidgets();
}
